export const MFA_MAX_ATTEMPTS = 5

export function normalizeMfaCode(value) {
  const compact = String(value || '').replace(/\s+/g, '')
  if (/^\d{6}$/.test(compact)) return compact
  if (/^[A-Za-z0-9]{4,}-[A-Za-z0-9]{4,}$/.test(compact)) return compact.toUpperCase()
  return ''
}

export function isInvalidMfaCodeError(error) {
  return error?.response?.status === 422
}
